import ListingResponsibleManagerModal from '../../ListingResponsibleManagerModal'
import { getListingResponsibleManagerInitialValues } from '../../ListingResponsibleManagerModal.utils'

export function useListingResponsibleManagerModalOpener({
  listingData,
  setModal,
  onClose,
  onConflict,
  onReload,
}) {
  async function handleSaveResponsibleManager() {
    onClose()

    return onReload()
  }

  function handleOpenResponsibleManagerModal() {
    setModal(
      <ListingResponsibleManagerModal
        initialValues={getListingResponsibleManagerInitialValues(
          listingData?.responsible_user
        )}
        listingId={listingData.id}
        version={listingData.version}
        onClose={onClose}
        onConflict={onConflict}
        onSave={handleSaveResponsibleManager}
      />
    )
  }

  return { handleOpenResponsibleManagerModal }
}
